import { createSlice } from "@reduxjs/toolkit";
import { MEDIA_SIZES } from "../util/useMediaQuery";

const REDUCER_KEY = "config";
export const CONFIG_REDUCER_KEY = REDUCER_KEY;

const slice = createSlice({
  name: REDUCER_KEY,
  initialState: {
    pending: true,
    data: {},
    mediaSize: MEDIA_SIZES.desktop,
  },
  reducers: {
    setConfig: (state, { payload }) => {
      state.pending = false;
      state.data = payload;
    },
    setMediaSize: (state, { payload }) => {
      state.mediaSize = payload;
    },
  },
});

export const { setConfig, setMediaSize } = slice.actions;

export const fetchConfig = () => async (dispatch) => {
  const res = await window.fetch("./config.json");
  const {
    header,
    headerMessage,
    updateInterval,
    timezone,
    offlineTimeFilter,
    trackHistoryHours,
    apiRoot,
    mapLat,
    mapLng,
    mapZoom,
    hideTrackButtons,
    leafletTileUrl,
    button,
    themeColor,
    statics,
    clock,
  } = await res.json();

  dispatch(
    setConfig({
      header,
      headerMessage,
      updateInterval: +updateInterval,
      timezone,
      offlineTimeFilter: +offlineTimeFilter,
      trackHistoryHours: +trackHistoryHours,
      apiRoot,
        statics,
      mapCenter: {
        lat: +mapLat,
        lng: +mapLng,
        zoom: +mapZoom,
      },
      hideTrackButtons,
      leafletTileUrl,
      button,
      themeColor,
      clock,
    })
  );
};

const getConfig = (state) => state[REDUCER_KEY];

const getData = (state) => getConfig(state).data;
export const getIsConfigReady = (state) => getConfig(state).pending === false;

export const getConfigHeader = (state) => getData(state).header;
export const getConfigUpdateInterval = (state) => getData(state).updateInterval;
export const getConfigTimezone = (state) => getData(state).timezone;
export const getOfflineTimeFilter = (state) => getData(state).offlineTimeFilter;
export const getTrackHistoryHours = (state) => getData(state).trackHistoryHours;
export const getApiRoot = (state) => getData(state).apiRoot;
export const getConfigMapCenter = (state) => getData(state).mapCenter;
export const getConfigHeaderMessage = (state) => getData(state).headerMessage;
export const getConfighideTrackButtons = (state) =>
  getData(state).hideTrackButtons;
export const getConfigLeafletTileUrl = (state) => getData(state).leafletTileUrl;
export const getConfigButton = (state) => getData(state).button;
export const getConfigThemeColor = (state) => getData(state).themeColor;
export const getMediaSize = (state) => getConfig(state).mediaSize;
export const getConfigClock = (state) => getData(state).clock;
export const getStaticConfig = (state) => getData(state).statics;

export default slice.reducer;
